import { render } from "./WeatherCard.vue?vue&type=template&id=63b1128f"
import script from "./WeatherCard.vue?vue&type=script&lang=js"
export * from "./WeatherCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__